import { CheckSquareOffset } from "@phosphor-icons/react";

import { HookObject, ListItemsHooks } from "@/plugins/types";
import { ReviewCenter } from "./ReviewCenter";
import { ReviewRoom } from "./ReviewRoom";

// RV-1 — Launch Reviews: one place to review the team's work (Specs/Launch Reviews — PRD).
// Shown only to accounts given the "reviews" permission, and to admins (Kyle, Oct 25: not every Agents account yet).
const canReview = (permissions: string[]) => permissions.includes("reviews") || permissions.includes("admin");

export const onListItems = (hook: HookObject, _: unknown, __: unknown, { permissions = [] as string[] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!canReview(permissions)) return [];
    return [{ label: "Reviews", icon: <CheckSquareOffset className="text-lg" />, href: "/reviews", order: 1.5 }];
  }
  if (hook.id === ListItemsHooks.ROUTES) {
    if (!canReview(permissions)) return [];
    return [
      { path: "/reviews", element: <ReviewCenter /> },
      { path: "/reviews/:id", element: <ReviewRoom /> },
    ];
  }
};

export { ReviewCenter, ReviewRoom };
